import { gql, useQuery } from "@apollo/client";

export interface AgreementForEdit {
  id: string;
  name: string;
  agreementType: string;
  agreementTypeId: string | null;
  state: string | null;
  jurisdictionKind: string;
  jurisdictionValue: string | null;
  isActive: boolean;
  agreementHtml: string;
  simpleHtml: string;
  headerHtml: string | null;
  footerHtml: string | null;
  topLeftHtml: string | null;
  topRightHtml: string | null;
  countersignerName: string | null;
  countersignerSignatureKey: string | null;
  marginTop: number | null;
  marginBottom: number | null;
  marginLeft: number | null;
  marginRight: number | null;
  showFirstPageMargins: boolean | null;
  signatureBlockHtml: string | null;
  signatoryPrefix: string | null;
  signatorySuffix: string | null;
  previewImageUrl: string | null;
  previewContentHash: string | null;
  previewGeneratedAt: string | null;
  tenantId: string;
  createdAt: string;
}

export interface TenantDefaultsForEdit {
  id: string;
  name: string;
  defaultHeaderHtml: string | null;
  defaultFooterHtml: string | null;
  defaultCountersignerName: string | null;
  defaultCountersignerSignatureKey: string | null;
  defaultMarginTop: number | null;
  defaultMarginBottom: number | null;
  defaultMarginLeft: number | null;
  defaultMarginRight: number | null;
  defaultTopLeftHtml: string | null;
  defaultTopRightHtml: string | null;
  defaultShowFirstPageMargins: boolean | null;
  defaultSignatureBlockHtml: string | null;
  cdnBaseUrl: string;
}

const AGREEMENT_FOR_EDIT = gql`
  query AgreementForEdit($id: String!) {
    Agreement(id: $id) {
      id
      name
      agreementType
      agreementTypeId
      state
      jurisdictionKind
      jurisdictionValue
      isActive
      agreementHtml
      simpleHtml
      headerHtml
      footerHtml
      topLeftHtml
      topRightHtml
      countersignerName
      countersignerSignatureKey
      marginTop
      marginBottom
      marginLeft
      marginRight
      showFirstPageMargins
      signatureBlockHtml
      signatoryPrefix
      signatorySuffix
      previewImageUrl
      previewContentHash
      previewGeneratedAt
      tenantId
      createdAt
    }
    tenantSettings {
      id
      name
      defaultHeaderHtml
      defaultFooterHtml
      defaultCountersignerName
      defaultCountersignerSignatureKey
      defaultMarginTop
      defaultMarginBottom
      defaultMarginLeft
      defaultMarginRight
      defaultTopLeftHtml
      defaultTopRightHtml
      defaultShowFirstPageMargins
      defaultSignatureBlockHtml
      cdnBaseUrl
    }
  }
`;

export function useAgreementData(id: string | undefined) {
  const result = useQuery<{
    Agreement: AgreementForEdit | null;
    tenantSettings: TenantDefaultsForEdit;
  }>(AGREEMENT_FOR_EDIT, {
    variables: { id: id ?? "" },
    skip: !id,
    fetchPolicy: "cache-and-network",
  });

  return {
    agreement: result.data?.Agreement ?? null,
    tenant: result.data?.tenantSettings ?? null,
    loading: result.loading,
    error: result.error,
    refetch: result.refetch,
  };
}
